import React, { useState } from "react";
import DuringFeedback from "./DuringFeedBack";
import DuringRoleplay from "./DuringRolePlay";
import HumanOversight from "./HumanOversight";
import styles from "../../_css/EscalationManagement.module.css";
import { useSearchParams } from "react-router-dom";

const Index = () => {
    const [searchParams] = useSearchParams();
    const tabFromUrl = searchParams.get("tab") || "During Feedback";
    const [activeFilter, setActiveFilter] = useState(
        tabFromUrl
    );

    const filterTabs = [
        { id: 'during-feedback', label: 'During Feedback' },
        { id: 'during-role-play', label: 'During Role Play' },
        { id: 'human-oversight', label: 'Human Oversight' }
    ];

    const renderActiveComponent = () => {
        switch (activeFilter) {
            case "During Feedback":
                return <DuringFeedback />;
            case "During Role Play":
                return <DuringRoleplay />;
            case "Human Oversight":
                return <HumanOversight />;
            default:
                return <DuringFeedback />;
        }
    };

    return (
        <div className={styles.Indexcontainer}>
            {/* Header / Filter Tabs */}
            <div className={styles.header}>
                <div className={styles.filterTabs}>
                    {filterTabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveFilter(tab.label)}
                            className={`${styles.tabButton} ${activeFilter === tab.label ? styles.activeTab : styles.inactiveTab
                                }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Render Tab Component - each handles its own data */}
            {renderActiveComponent()}
        </div>
    );
};

export default Index;